import { calculateOrgPermissions } from '../../../../../backend/features/accounts/shared';
import { transformOrgColumnIntoDataObject } from '../../../../../backend/features/accounts/utils/transformOrgColumnIntoDataObject';
import { flatten } from '../../../../../backend/utils/FilterUtils';
import { filterAccountColumnsOrganizationsByPermission } from '../../shared';
export function handleRemoveAccountFromOrganization({ appContext, secureBulkActionParams: { createdBy, data, isCancelled, updateProcessedCount }, row, accountStorage, actionOwner, processedIndex, }) {
    const currentAccountOrgRoles = transformOrgColumnIntoDataObject(row.columns.orgRole);
    const currentAccountOrgStatuses = transformOrgColumnIntoDataObject(row.columns.orgStatus);
    const ownerSystemPermissions = appContext.appState.settings.systemRoleMap[actionOwner.data.systemRole].permissions;
    const { orgRole: allowedToManageOrgRoles, orgStatus: allowedToManageOrgStatuses } = filterAccountColumnsOrganizationsByPermission(row.columns, row.id, ['manage-members'], {
        id: createdBy,
        orgPermissions: calculateOrgPermissions(appContext, actionOwner.data),
        systemPermissions: ownerSystemPermissions,
    });
    let orgStatusValue;
    if (allowedToManageOrgRoles[data.params.organizationId] && currentAccountOrgRoles[data.params.organizationId]) {
        delete currentAccountOrgRoles[data.params.organizationId];
    }
    if (allowedToManageOrgStatuses[data.params.organizationId] && currentAccountOrgStatuses[data.params.organizationId]) {
        orgStatusValue = allowedToManageOrgStatuses[data.params.organizationId];
        delete currentAccountOrgStatuses[data.params.organizationId];
    }
    accountStorage.post({
        action: 'partial-update',
        id: row.id,
        data: {
            orgRole: currentAccountOrgRoles,
            orgStatus: currentAccountOrgStatuses,
        },
        actionParams: {
            bulkAction: true,
        },
    });
    updateProcessedCount(processedIndex + 1);
    const flatFilter = flatten(data.secureParams.secureFilter);
    const statusValues = new Set();
    for (const filter of flatFilter) {
        if ('column' in filter && filter.op === 'overlap' && 'value' in filter && filter.column === 'orgStatus') {
            if (Array.isArray(filter.value)) {
                filter.value.forEach((value) => statusValues.add(value));
            }
        }
    }
    const isDeleted = orgStatusValue ? statusValues.has(`${data.params.organizationId}_${orgStatusValue}`) : false;
    return { cancel: isCancelled(), deleted: isDeleted };
}
